import React from "react";
import { Box, IconButton, Typography, Divider } from "@mui/material";
import { ReactComponent as CrossIcon } from "../../images/crossvector.svg";
import useWrongAnswerStyle from "./wrongAnswerStyle";
// DeclarationCheckBox moved to QuestionsAndOptions

function WrongAnswer({
  correctOptionIds,
  options,
  selectLanguage,
  isNoOptionSelected,
  selectedOptionIds,
  answer = "",
  isFillInTheBlank = false,
  questionType = "",
  correctFillUpOption,
  correctOptionMatch,
  selectedOptionMatch,
}) {
  const classes = useWrongAnswerStyle();

  const partiallyInCorrect = () => {
    const matchedOptions = correctOptionIds?.filter((cId) =>
      selectedOptionIds.includes(cId),
    );

    return matchedOptions?.length === selectedOptionIds?.length;
  };
  const getMatchResult = (correct = {}, selected = {}) => {
    if (!correct || typeof correct !== "object") return [];

    return Object.keys(correct).map((key) => {
      const correctValue = correct?.[key]?.[0] ?? null;
      const selectedValue = selected?.[key]?.[0] ?? null;

      return {
        question: key,
        correct: correctValue,
        selected: selectedValue,
        isCorrect: correctValue === selectedValue,
      };
    });
  };

  const matchResult = React.useMemo(() => {
    if (!correctOptionMatch || !selectedOptionMatch) return [];
    return getMatchResult(correctOptionMatch, selectedOptionMatch);
  }, [correctOptionMatch, selectedOptionMatch]);

  // const errorMessage = isFillInTheBlank
  //   ? answer
  //     ? "Oops! Your Answer Is Wrong."
  //     : "Oops! You Have Not Answered This Question. "
  //   : isNoOptionSelected
  //   ? "Oops! You Have Not Selected Any Option For This Question."
  //   : questionType === "Multiple Choice"
  //   ? "Your Answer Is Partially Correct."
  //   : "Oops! Your Answer Is Wrong.";

  let errorMessage = "";

  if (isFillInTheBlank) {
    if (answer) {
      errorMessage = "Oops! Your Answer Is Wrong.";
    } else {
      errorMessage = "Oops! You Have Not Answered This Question.";
    }
  } else if (isNoOptionSelected) {
    errorMessage = "Oops! You Have Not Selected Any Option For This Question.";
  } else if (questionType === "Multiple Choice") {
    if (partiallyInCorrect()) {
      errorMessage = "Your Answer Is Partially Correct.";
    } else {
      errorMessage = "Oops! Your Answer Is Wrong.";
    }
  } else {
    errorMessage = "Oops! Your Answer Is Wrong.";
  }

  const getAlphabetLetter = (index) => {
    if (index === null) return "";
    return String.fromCharCode(65 + index);
  };

  const getSolutionText = (option) => {
    return selectLanguage === "english"
      ? option.solution_en
      : option.solution_hi;
  };

  const FillUpAnswer = () => (
    <Typography variant="body1" component="div" className={classes.solutionText}>
      <span className={classes.spanText}>Answer:</span> The correct answer is{" "}
      {options.map((item) =>
        item.correct_option ? (
          <div
            key={item.id}
            style={{ display: "inline" }}
            dangerouslySetInnerHTML={{ __html: getSolutionText(item) }}
          ></div>
        ) : (
          <React.Fragment key={item.id}></React.Fragment>
        ),
      )}
      {answer ? <span> and you've answered: {answer}</span> : <></>}
    </Typography>
  );

  const RangeAnswer = () => (
    <Typography variant="body1" component="div" className={classes.solutionText}>
      <span className={classes.spanText}>Answer:</span> The correct range is{" "}
      {options.map((item) =>
        item.correct_option ? (
          <span key={item.id}>
            <strong>{getSolutionText(item)}</strong>
          </span>
        ) : null,
      )}
      {answer ? (
        <span>
          {" "}and your answer <strong>{answer}</strong> does not fall within
          this range.
        </span>
      ) : (
        <span> and you have not entered any answer.</span>
      )}
    </Typography>
  );

  const MCQAnswer = () => (
    <Typography variant="body1" component="div" className={classes.solutionText}>
      <span className={classes.spanText}>Answer:</span> The correct options are:
      {correctOptionIds
        ?.map((id) =>
          getAlphabetLetter(options.findIndex((item) => item.id === id)),
        )
        .join(",") ?? ""}{" "}
      {selectedOptionIds.length > 0 ? (
        <>
          <span>and you've selected:</span>
          {selectedOptionIds
            ?.map((id) =>
              getAlphabetLetter(options.findIndex((item) => item.id === id)),
            )
            .join(",") ?? ""}
        </>
      ) : (
        <></>
      )}
    </Typography>
  );
  const MatchAnswer = () => (
    <Typography variant="body1" component="div" className={classes.solutionText}>
      <span className={classes.spanText}>Answer:</span>

      {matchResult.length > 0 &&
        matchResult.map((item) => (
          <div key={item.question}>
            <strong>{item.question}</strong> → Correct: {item.correct} |
            Selected:{" "}
            <span
              style={{
                color: item.isCorrect ? "green" : "red",
              }}
            >
              {item.selected}
            </span>
          </div>
        ))}
    </Typography>
  );

  const SCQAnswer = () => (
    <Typography variant="body1" component="div" className={classes.solutionText}>
      <span className={classes.spanText}>Answer:</span> The correct option is{" "}
      {correctOptionIds
        ?.map((id) =>
          getAlphabetLetter(options.findIndex((item) => item.id === id)),
        )
        .join(",") ?? ""}{" "}
      {selectedOptionIds.length > 0 ? (
        <>
          <span>and you've selected:</span>
          {selectedOptionIds
            ?.map((id) =>
              getAlphabetLetter(options.findIndex((item) => item.id === id)),
            )
            .join(",") ?? ""}
        </>
      ) : (
        <></>
      )}
    </Typography>
  );

  return (
    <Box>
      <div className={classes.crossAndRedText}>
        <IconButton>
          <CrossIcon className={classes.circularIcon} />
        </IconButton>
        <Typography variant="body1" className={classes.textInRed}>
          {errorMessage}
        </Typography>
      </div>

      {/* MCQ */}
      {questionType === "Multiple Choice" && <MCQAnswer />}
      {/*  SCQ */}
      {questionType === "Single" && <SCQAnswer />}
      {/* FILL UP */}
      {isFillInTheBlank && questionType !== "Range" && <FillUpAnswer />}
      {/* RANGE */}
      {questionType === "Range" && <RangeAnswer />}

      {questionType.includes("Match") && <MatchAnswer />}

      <Divider className={classes.horizontalLine} />
    </Box>
  );
}

export default WrongAnswer;
